import { render, staticRenderFns } from "./CreateMailSubscription.vue?vue&type=template&id=5735b39b&"
import script from "./CreateMailSubscription.vue?vue&type=script&lang=js&"
export * from "./CreateMailSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports